export default (number: number): string => {
  const rankRegExp = /(\d)(?=(\d{3})+([^\d]|$))/g
  return number?.toString()?.replace(rankRegExp, '$1 ')
}
